module.exports = __webpack_public_path__ + "img/bx_cba_detail.ef601b26.png";